module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-5.bd210958.jpg";